import CancelablePromise from "mn-utils/CancelablePromise";
import {apiRequestAdmin} from "../ws";
import {
  ENDPOINT_ADMIN_STATS_MONTHLY,
  ENDPOINT_ADMIN_STATS_PAYMENTS,
  ENDPOINT_ADMIN_STATS_PENDING_WITHDRAWS
} from "../../constants/api";

export function apiAdminMonthlyPaymentOverview(params) {
  if (process.env.MOCK) {
    return CancelablePromise.delay(2000, {});
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_STATS_MONTHLY, params);
}

export function apiAdminPaymentOverview(params) {
  if (process.env.MOCK) {
    return CancelablePromise.delay(2000, {});
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_STATS_PAYMENTS, params);
}

export function apiAdminPendingWithdrawalsOverview(params) {
  if (process.env.MOCK) {
    return CancelablePromise.delay(2000, {});
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_STATS_PENDING_WITHDRAWS, params);
}
